<header class="quotation-header">
  <div class="header-collapse-toggle" (click)="toggleCollapse()">
    <i class="pi" [ngClass]="{
        'pi-chevron-right': isCollapsed,
        'pi-chevron-left': !isCollapsed
      }"></i>
  </div>

  <div class="header-content" [class.collapsed]="isCollapsed">
    <!-- User Controls -->
    <div class="user-controls">
      <div class="user-profile" (click)="toggleUserMenu()" [class.active]="userMenuOpen">
        <div *ngIf="isCollapsed">
          <img src="../../../../assets/quotation-dashboard/Mask group.png" alt="User" class="user-avatar" />
        </div>
        <div class="left-content" *ngIf="!isCollapsed">
          <div class="avatar-image">
            <img src="../../../../assets/quotation-dashboard/Mask group.png" alt="User" class="user-avatar" />
          </div>
          <div class="user-info">
            <span class="username">{{ username }}</span>
            <span class="user-role">{{ userRole }}</span>
          </div>
        </div>

        <!-- Right-aligned dots icon -->
        <div class="menu-wrapper">
          <i class="pi pi-ellipsis-v dots-icon" (click)="$event.stopPropagation(); menu.toggle($event)"></i>
          <p-menu #menu [popup]="true" [model]="items" [appendTo]="'body'" styleClass="custom-menu">
          </p-menu>
        </div>
      </div>
    </div>

    <div class="nav-container" @fadeInRight>
      <nav class="main-nav">
        <ul>
          <li>
            <a routerLink="/quotation-part/quotation-dashboard" routerLinkActive="active">
              <i class="pi pi-chart-bar"></i>
              <span>Dashboard</span>
            </a>
          </li>
          <li>
            <a routerLink="/quotation-part/quotation-weekly-dashboard" routerLinkActive="active">
              <i class="pi pi-calendar-times"></i>
              <span>Weekly Dashboard</span>
            </a>
          </li>
          <li>
            <a routerLink="/quotation-part/quotation-list" routerLinkActive="active">
              <i class="pi pi-list"></i>
              <span>Quotations</span>
            </a>
          </li>
          <li>
            <a routerLink="/quotation-part/quotation-manage-kikf1" routerLinkActive="active">
              <i class="pi pi-database"></i>
              <span>KIK F1 Data Manage</span>
            </a>
          </li>
          <li>
            <a routerLink="/quotation-part/quotation-status" routerLinkActive="active">
              <i class="pi pi-info-circle"></i>
              <span>Status</span>
            </a>
          </li>
          <li>
            <a routerLink="/quotation-part/customer-list" routerLinkActive="active">
              <i class="pi pi-users"></i>
              <span>Customers</span>
            </a>
          </li>

          <!-- Horizontal line -->
          <li class="menu-divider">
            <div class="divider-line"></div>
          </li>

          <!-- Additional menu items -->
          <li>
            <a routerLink="/quotation-part/settings-link"  routerLinkActive="active">
              <i class="pi pi-cog"></i>
              <span>Application Settings</span>
            </a>
          </li>
          <li>
            <a href="#" class="/quotation-part/help-link">
              <i class="pi pi-question-circle"></i>
              <span>Get Technical Help</span>
            </a>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</header>